import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { LotteryInstallmentConfigurationModel } from "src/app/model/LotteryInstallmentConfigurationModel";
import { SchemeInstallmentConfigurationModel } from "src/app/model/SchemeInstallmentConfigurationModel";
import { InstallmentConfigService } from "src/app/services/installment-config.service";

import { ModalController } from "@ionic/angular";
import { InstallmentConfigEditModalComponent } from "../installment-config/installment-config-edit-model/installment-config-edit-model.component";
import { InstallmentConfigModalComponent } from "../installment-config/installment-config-modal/installment-config-modal.component";

import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { TenementListResponse } from "src/app/model/TenementListResponse";
import { TenementInsConfigInitModel } from "src/app/model/TenementInsConfigInitModel";
import { TenementInstallmentConfigAddModalComponent } from "./tenement-installment-config-add-model/tenement-installment-config-add-model.component";
import { TenementInstallmentConfigService } from "src/app/services/tenement-installment-config.service";
import { Page } from "src/app/model/Page";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";

@Component({
  selector: "app-secure-installment-config",
  templateUrl: "./tenement-installment-config.component.html",
  styleUrls: ["./tenement-installment-config.component.scss"],
})
export class TenementInstallmentConfigComponent implements OnInit {
  isLoading = false;
  lotteries: { [key: number]: string };
  isSearchDisabled: boolean = false;
  schemes: { [key: number]: string };
  building: string[];
  twing: string[];
  floor: number[];
  flatNo: number[];
  selectedLottery: number;
  selectedScheme: number;
  selectedBldg: string = "";
  selectedWing: string = "";
  selectedFloor: string = "";
  selectedFlatNo: number;
  selectedTenementKeys: number[];
  tenementKeys: number[] = [];
  installmentTypes: { [key: number]: string };
  lotteryInstallmentConfigs: LotteryInstallmentConfigurationModel[] = [];
  schemeInstallmentConfigs: SchemeInstallmentConfigurationModel[] = [];
  isSubmitDisabled: boolean = false;
  lotteryKey: { key: number; value: string };
  schemeKey: { key: number; value: string };
  isAddAllowedForLottery: boolean;
  isAddAllowedForScheme: boolean;
  otherInstallmentNames: string[];
  filterFormGroup: FormGroup = new FormGroup({});
  tenementDetails: Page<TenementListResponse>;
  dataSource: MatTableDataSource<TenementListResponse> =
    new MatTableDataSource();
  selectedTenements: TenementListResponse[] = [];
  selectedTenement: TenementListResponse;
  isHeaderCheckboxChecked: boolean = false;
  count: string;
  allTenementConfig: TenementInsConfigInitModel[];
  pageSizeOptions: number[] = [10, 25, 100];
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = [
    "checkbox",
    "buildingNo",
    "wing",
    "floor",
    "flatNo",
    "schemeCode",
    "action",
  ];

  constructor(
    private router: Router,
    private modalCtrl: ModalController,
    private installmentConfigService: InstallmentConfigService,
    private tenementInsConfigService: TenementInstallmentConfigService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    this.tenementInsConfigService.initTenementInsConfigForm().subscribe(
      (data) => {
        this.isLoading = false;
        if (data.status === "SUCCESS") {
          this.lotteries = data.lotteries;
          this.otherInstallmentNames = data.otherInstallmentNames;
          this.isLoading = false;
        } else {
          this.installmentConfigService.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.installmentConfigService.errorToast(
          error?.error?.message || error?.error?.errorMessage
        );
        this.isLoading = false;
      }
    );

    this.filterFormGroup = new FormGroup({
      lotteryFilter: new FormControl(null, [Validators.required]),
      schemeFilter: new FormControl(null, [Validators.required]),
      buildingFilter: new FormControl(null),
      wingFilter: new FormControl(null),
      floorFilter: new FormControl(null),
    });
  }

  onLotteryChange(e: any) {
    this.schemes = {};
    this.building = [];
    this.twing = [];
    this.floor = [];
    this.flatNo = [];

    this.selectedLottery = e.key;

    if (e?.key > 0) {
      this.isLoading = true;
      this.tenementInsConfigService.initWithLottery(e.key).subscribe(
        (data) => {
          this.isLoading = false;
          if (data.status === "SUCCESS") {
            this.schemes = data.schemes;
            this.isSearchDisabled = false;
          } else {
            this.installmentConfigService.errorToast(data.errorMessage);
          }
        },
        (error) => {
          this.installmentConfigService.errorToast(
            error?.error?.message || error?.error?.errorMessage
          );
          this.isLoading = false;
        }
      );
    }
  }

  onSchemeChange(e: any) {
    this.building = [];
    this.twing = [];
    this.floor = [];
    this.flatNo = [];

    if (e?.key > 0) {
      this.selectedScheme = e.key;
      this.isLoading = true;

      this.tenementInsConfigService
        .initWithScheme(this.selectedLottery, e.key)
        .subscribe(
          (data) => {
            this.isLoading = false;
            if (data.status === "SUCCESS") {
              this.building = data.bldg;
              this.isSearchDisabled = false;
            } else {
              this.tenementInsConfigService.errorToast(data.errorMessage);
            }
          },
          (error) => {
            this.tenementInsConfigService.errorToast(
              error?.error?.message || error?.error?.errorMessage
            );
            this.isLoading = false;
          }
        );
    }
  }

  onBldgChange(e: any) {
    if (e == null) {
      console.log("Is null");
    }

    this.twing = [];
    this.floor = [];
    this.flatNo = [];
    if (e) {
      this.selectedBldg = e;
      this.isLoading = true;
      this.tenementInsConfigService
        .initWithBldg(
          this.selectedLottery,
          this.selectedScheme,
          this.selectedBldg
        )
        .subscribe(
          (data) => {
            this.isLoading = false;
            if (data.status === "SUCCESS") {
              this.twing = data.wing;
              this.isSearchDisabled = false;
              console.log("****this.wing>>>>", this.twing);
              console.log("****this.building>>>>", this.building);
            } else {
              this.tenementInsConfigService.errorToast(data.errorMessage);
            }
          },
          (error) => {
            this.tenementInsConfigService.errorToast(
              error?.error?.message || error?.error?.errorMessage
            );
            this.isLoading = false;
          }
        );
    }
  }

  onWingChange(e: any) {
    this.floor = [];
    this.flatNo = [];

    if (e) {
      this.selectedWing = e;
      console.log("****this.selectedWing>>>>>>", this.selectedWing);
      this.isLoading = true;
      this.tenementInsConfigService
        .initWithWing(
          this.selectedLottery,
          this.selectedScheme,
          this.selectedBldg,
          this.selectedWing
        )
        .subscribe(
          (data) => {
            this.isLoading = false;
            if (data.status === "SUCCESS") {
              console.log("In SUCCESS");
              this.floor = data.floor;
              this.isSearchDisabled = false;
            } else {
              console.log("In ERROR");
              this.tenementInsConfigService.errorToast(data.errorMessage);
            }
          },
          (error) => {
            console.log("In subscribe ERROR");
            this.tenementInsConfigService.errorToast(
              error?.error?.message || error?.error?.errorMessage
            );
            this.isLoading = false;
          }
        );
    }
  }

  onFloorChange(e: any) {
    console.log("On Floor Change>>>>", e);
    this.flatNo = [];
    if (e) {
      this.selectedFloor = e;
      console.log("****this.selectedFloor>>>>>>", this.selectedFloor);
      this.isLoading = true;
      this.tenementInsConfigService
        .initWithFloor(
          this.selectedLottery,
          this.selectedScheme,
          this.selectedBldg,
          this.selectedWing,
          this.selectedFloor
        )
        .subscribe(
          (data) => {
            this.isLoading = false;
            if (data.status === "SUCCESS") {
              this.flatNo = data.flat;
              this.isSearchDisabled = false;
              console.log("****this.flatNo>>>>", this.flatNo);
            } else {
              this.tenementInsConfigService.errorToast(data.errorMessage);
            }
          },
          (error) => {
            this.tenementInsConfigService.errorToast(
              error?.error?.message || error?.error?.errorMessage
            );
            this.isLoading = false;
          }
        );
    }
  }

  toggleHeaderCheckbox(checked: boolean) {
    this.isHeaderCheckboxChecked = checked;
    console.log(
      "this.isHeaderCheckboxChecked before check>>",
      this.isHeaderCheckboxChecked
    );
    if (checked) {
      if (
        this.dataSource.filteredData.filter(
          (element) => element.tenementConfigExists === "Y"
        ).length > 0
      ) {
        console.log("Tenement have config.");
        console.log("this.selectedElement", this.selectedTenements);
        this.dataSource.data.forEach((element: TenementListResponse) => {
          if (element.tenementConfigExists === "N") {
            this.selectedTenements.push(element);
          }
        });
        console.log(
          "this.selectedElement after filter data>>",
          this.selectedTenements
        );
        this.count = this.selectedTenements.length.toString();

        if (this.selectedTenements.length === 0) {
          setTimeout(() => {
            this.isHeaderCheckboxChecked = false;
          });
          return this.tenementInsConfigService.errorToast(
            "No eligible data is avaiable"
          );
        }
      } else {
        this.selectedTenements = this.dataSource.filteredData.slice();
        console.log("Fill Select all", this.selectedTenements);
      }
    } else {
      this.selectedTenements = [];
      console.log("Empty Select all", this.selectedTenements);
    }
    this.count = this.selectedTenements.length.toString();
  }

  onCheckboxChange(row: TenementListResponse) {
    console.log("Check row checked/ unchecked", row);
    if (row.isSelected) {
      this.selectedTenements.push(row);
      console.log("this.selectedElement", this.selectedTenements);
    } else {
      const index = this.selectedTenements.indexOf(row);
      if (index !== -1) {
        this.selectedTenements.splice(index, 1);
      }
      console.log("this.selectedElement", this.selectedTenements);
    }
    this.count = this.selectedTenements.length.toString();
  }

  isRowSelected(row: TenementListResponse): boolean {
    return this.selectedTenements.includes(row);
  }

  onSearch() {
    this.isLoading = true;
    this.isHeaderCheckboxChecked = false;
    this.selectedTenements = [];
    this.count = this.selectedTenements.length.toString();

    if (!this.selectedLottery) {
      this.isLoading = false;
      this.isSearchDisabled = false;
      return this.tenementInsConfigService.errorToast(
        "Please Select Lottery from the filter."
      );
    }

    if (!this.selectedScheme) {
      this.isLoading = false;
      this.isSearchDisabled = false;
      return this.tenementInsConfigService.errorToast(
        "Please Select Scheme from the filter."
      );
    }

    if (this.filterFormGroup.valid) {
      this.tenementInsConfigService
        .getAllTenementDtls(
          this.selectedLottery,
          this.selectedScheme,
          this?.selectedBldg,
          this?.selectedWing,
          this?.selectedFloor,
          this.currentPage,
          this.pageSize
        )
        .subscribe(
          (data) => {
            this.isLoading = false;
            if (data.status === "SUCCESS") {
              this.isLoading = false;
              this.isSearchDisabled = false;

              this.tenementDetails = data.allTenements;
              this.dataSource = new MatTableDataSource(
                this.tenementDetails.content
              );
              setTimeout(() => {
                this.paginator.pageIndex = this.currentPage;
                this.paginator.length = this.tenementDetails.totalElements;
                console.log(this.paginator.pageIndex);
                console.log(this.paginator.length);
              });
              this.isLoading = false;
            } else {
              this.tenementInsConfigService.errorToast(data.errorMessage);
            }
          },
          (error) => {
            this.tenementInsConfigService.errorToast(
              error?.error?.message || error?.error?.errorMessage
            );
            this.isLoading = false;
          }
        );
    }
  }

  edit(element: TenementListResponse) {
    this.isSearchDisabled = true;
    console.log("Selected Tenement For Edit : ", element);

    if (!element) {
      return this.tenementInsConfigService.errorToast(
        "Please Refresh and click again."
      );
    }

    this.selectedTenement = element;

    this.tenementKeys = [];
    this.tenementKeys.push(this.selectedTenement.tenementKey);

    this.tenementInsConfigService
      .getConfigurationDetailsOfTenement(this.selectedTenement.tenementKey)
      .subscribe(async (configResponseData) => {
        console.log("Data Received for EDIT >>>> ", configResponseData);
        if (configResponseData.status == "SUCCESS") {
          this.isSearchDisabled = false;
          this.allTenementConfig =
            configResponseData.tenementInsConfigInitModels;
          console.log(
            "this.allTenementConfig Jayesh EDIT>>",
            this.allTenementConfig
          );
          const modal = await this.modalCtrl.create({
            component: TenementInstallmentConfigAddModalComponent,
            cssClass: "master-modal-lg",
            componentProps: {
              selectedTenement: this.selectedTenement,
              tenementConfigs: this.allTenementConfig,
              lotteryCode: configResponseData.lotteryCode,
              lotteryName: configResponseData.lotteryName,
              installmentTypes: configResponseData.installmentType,
              otherInstallmentNames: configResponseData.otherInstallmentNames,
              saved: true,
              tenementKeys: this.tenementKeys,
            },
          });

          modal.present();
          this.isLoading = false;

          const { data, role } = await modal.onWillDismiss();

          if (role === "update") {
            this.isLoading = true;
            console.log("Data received from Modal for update >>>", data);

            console.log("SUCCESS updateTenementConfig", data);

            this.tenementInsConfigService.updateTenementConfig(data).subscribe(
              (data) => {
                if (data.status === "SUCCESS") {
                  this.isLoading = false;
                  console.log("SUCCESS saveTenementConfig", data);
                  this.resetFilter();
                  this.loadData();
                  this.tenementInsConfigService.successToast(
                    "Data Saved SuccessFully."
                  );
                } else {
                  this.isLoading = false;
                  this.tenementInsConfigService.errorToast(data.errorMessage);
                }
              },
              (error) => {
                this.isLoading = false;
                console.log("FAILURE saveTenementConfig", error);
                this.tenementInsConfigService.errorToast(data.errorMessage);
              }
            );
          }
        } else {
          this.tenementInsConfigService.errorToast(
            configResponseData.errorMessage
          );
        }
      });
  }

  async selectSingleConfig(element: TenementListResponse) {
    this.isSearchDisabled = true;
    this.isLoading = true;
    console.log("element selected >> ", element);
    this.selectedTenement = element;

    if (this.selectedTenement === null && this.selectedTenement === undefined) {
      this.isLoading = false;
      return this.tenementInsConfigService.errorToast(
        "Please select the tenement"
      );
    }

    this.tenementKeys = [];
    this.tenementKeys.push(this.selectedTenement.tenementKey);

    const tenementConfResp = await this.tenementInsConfigService
      .getConfigOfTenement(this.selectedTenement.tenementKey)
      .toPromise();

    console.log(
      "this.allTenementConfig ***** addSingleConfig>>",
      this.allTenementConfig
    );
    console.log("installmentType >>>> ", tenementConfResp.installmentType);

    if (tenementConfResp.status === "SUCCESS") {
      this.isSearchDisabled = false;
      this.allTenementConfig = tenementConfResp.tenementInsConfigInitModels;

      console.log(
        "this.allTenementConfig Jayesh addSingleConfig>>",
        this.allTenementConfig
      );
      if (this.allTenementConfig.length > 0) {
        return this.tenementInsConfigService.errorToast(
          "Config exists against the selected tenement"
        );
      }

      this.installmentTypes = tenementConfResp.installmentType;
      this.otherInstallmentNames = tenementConfResp.otherInstallmentNames;
      console.log(
        "this.allTenementConfig Jayesh addSingleConfig>>",
        this.allTenementConfig
      );
      console.log(
        "this.otherInstallmentNames Jayesh addSingleConfig>>",
        this.otherInstallmentNames
      );
      console.log("installmentType >>>> ", tenementConfResp.installmentType);

      const modal = await this.modalCtrl.create({
        component: TenementInstallmentConfigAddModalComponent,
        componentProps: {
          selectedTenement: this.selectedTenement,
          tenementConfigs: this.allTenementConfig,
          installmentTypes: this.installmentTypes,
          otherInstallmentNames: this.otherInstallmentNames,
          tenementKeys: this.tenementKeys,
        },
      });

      this.isLoading = false;
      modal.present();

      const { data, role } = await modal.onWillDismiss();

      if (role === "submit") {
        this.isLoading = true;
        console.log("Data received from Modal >>>", data);

        console.log("SUCCESS saveTenementConfig", data);

        this.tenementInsConfigService.saveTenementConfig(data).subscribe(
          (data) => {
            if (data.status === "SUCCESS") {
              this.isLoading = false;
              console.log("SUCCESS saveTenementConfig", data);
              this.resetFilter();
              this.loadData();
              this.tenementInsConfigService.successToast(
                "Data Saved SuccessFully."
              );
            } else {
              this.isLoading = false;
              this.tenementInsConfigService.errorToast(data.errorMessage);
            }
          },
          (error) => {
            this.isLoading = false;
            console.log("FAILURE saveTenementConfig", error);
            this.tenementInsConfigService.errorToast(data.errorMessage);
          }
        );
      }
    } else {
      this.isLoading = false;
      this.tenementInsConfigService.errorToast(tenementConfResp.errorMessage);
    }
  }
  catchSingleConfig(error) {
    console.error("Error occurred while fetching config:", error);
  }

  async selectMultipleConfig() {
    this.isLoading = true;
    this.tenementKeys = [];
    console.log("element selected >> ", this.selectedTenements);

    if (this.selectedTenements.length <= 0) {
      this.isLoading = false;
      return this.tenementInsConfigService.errorToast(
        "Please select the tenements"
      );
    }

    this.selectedTenements.forEach((element: TenementListResponse) => {
      if (element.tenementKey) {
        this.tenementKeys.push(element.tenementKey);
      }
    });

    console.log("Selected Multiple this.tenementKeys >> ", this.tenementKeys);

    const tenementsConfResp = await this.tenementInsConfigService
      .checkConfigOfTenements(this.tenementKeys)
      .toPromise();

    if (tenementsConfResp.status === "SUCCESS") {
      this.isLoading = false;
      console.log(
        "this.allTenementConfig ***** addSingleConfig>>",
        this.allTenementConfig
      );
      console.log("installmentType >>>> ", tenementsConfResp.installmentType);

      this.allTenementConfig = tenementsConfResp.tenementInsConfigInitModels;
      this.installmentTypes = tenementsConfResp.installmentType;
      this.otherInstallmentNames = tenementsConfResp.otherInstallmentNames;
      console.log(
        "this.allTenementConfig Jayesh addSingleConfig>>",
        this.allTenementConfig
      );
      console.log(
        "this.otherInstallmentNames Jayesh addSingleConfig>>",
        this.otherInstallmentNames
      );
      console.log("installmentType >>>> ", tenementsConfResp.installmentType);

      const modal = await this.modalCtrl.create({
        component: TenementInstallmentConfigAddModalComponent,
        componentProps: {
          selectedTenement: [],
          tenementConfigs: [],
          installmentTypes: this.installmentTypes,
          otherInstallmentNames: this.otherInstallmentNames,
          tenementKeys: this.tenementKeys,
          lotteryCode: tenementsConfResp.lotteryCode,
          lotteryName: tenementsConfResp.lotteryName,
        },
      });

      modal.present();

      const { data, role } = await modal.onWillDismiss();

      if (role === "submit") {
        this.isLoading = true;
        console.log("Data received from Modal >>>", data);

        this.tenementInsConfigService.saveTenementConfig(data).subscribe(
          (data) => {
            if (data.status === "SUCCESS") {
              this.isLoading = false;
              console.log("SUCCESS saveTenementConfig", data);
              this.resetFilter();
              this.loadData();
              this.tenementInsConfigService.successToast(
                "Data Saved SuccessFully."
              );
              this.count = "";
            } else {
              this.isLoading = false;
              this.tenementInsConfigService.errorToast(data.errorMessage);
            }
          },
          (error) => {
            this.isLoading = false;
            console.log("FAILURE saveTenementConfig", error);
          }
        );
      }
    } else {
      this.isLoading = false;
      this.tenementInsConfigService.errorToast(tenementsConfResp.errorMessage);
    }
  }
  catchMultipleConfig(error) {
    this.isLoading = false;
    console.error("Error occurred while fetching config:", error);
  }

  resetFilter() {
    this.loadData();
    // this.filterFormGroup.controls["lotteryFilter"].setValue(null);
    // this.filterFormGroup.controls["schemeFilter"].setValue(null);
    // this.filterFormGroup.controls["buildingFilter"].setValue(null);
    // this.filterFormGroup.controls["wingFilter"].setValue(null);
    // this.filterFormGroup.controls["floorFilter"].setValue(null);

    this.selectedScheme = 0;
    this.selectedLottery = 0;
    this.selectedBldg = "";
    this.selectedWing = "";
    this.selectedFloor = "";
    this.allTenementConfig = [];
    this.tenementKeys = [];
    this.selectedTenement = null;

    this.isSearchDisabled = false;
    this.dataSource = new MatTableDataSource(null);
    this.count = "";
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onSearch();
  }

  async onLotteryInstallmentConfigurationAdd() {
    let totalPercent =
      this.lotteryInstallmentConfigs &&
      this.lotteryInstallmentConfigs.length > 0 &&
      this.lotteryInstallmentConfigs.filter((s) => s.otherCharge === "N")
        .length > 0
        ? this.lotteryInstallmentConfigs
            .filter((s) => s.otherCharge === "N")
            .map((obj) => obj.installmentPercent)
            .reduce((o1, o2) => o1 + o2)
        : 0;
    console.log("totalPercent", totalPercent);
    let otherCharges =
      this.lotteryInstallmentConfigs &&
      this.lotteryInstallmentConfigs.length > 0 &&
      this.lotteryInstallmentConfigs.filter((l) => l.otherCharge === "Y")
        .length > 0
        ? Math.max.apply(
            Math,
            this.lotteryInstallmentConfigs
              .filter((s) => s.otherCharge === "Y")
              .map((obj) => obj.key)
          ) + 1
        : 11;

    let otherInstallmentNamesT = this.otherInstallmentNames.filter(
      (o) =>
        (this.lotteryInstallmentConfigs &&
        this.lotteryInstallmentConfigs.length > 0
          ? this.lotteryInstallmentConfigs
              .filter((l) => l.otherCharge === "Y")
              .map((l) => l.installmentType)
          : []
        ).indexOf(o) < 0
    );

    // if(totalPercent < 100) {
    let lotteryInstallmentConfigKeys = this.lotteryInstallmentConfigs?.map(
      (l) => l.key
    );
    let remainingInstallmentTypes = Object.keys(this.installmentTypes)
      ?.map((o) => {
        return { key: +o, value: this.installmentTypes[o] };
      })
      ?.filter((i) => lotteryInstallmentConfigKeys.indexOf(i.key) < 0)
      .sort((a, b) => {
        return a.key - b.key;
      });
    let installmentType = remainingInstallmentTypes[0];

    const modal = await this.modalCtrl.create({
      component: InstallmentConfigModalComponent,
      cssClass: "master-modal-lg",
      componentProps: {
        installmentConfigurationType: "Lottery",
        header: this.lotteries[this.lotteryKey.key],
        installmentType: totalPercent < 100 ? installmentType.value : null,
        installmentOrder: totalPercent < 100 ? installmentType.key : null,
        initialPercent: totalPercent < 100 ? 100 - totalPercent : 0,
        otherInstallmentType: !otherCharges ? "OTHER_CHARGES" : null,
        otherInstallmentOrder: otherCharges,
        otherInstallmentNames: otherInstallmentNamesT,
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === "submit") {
      console.log("data", data);
      this.lotteryInstallmentConfigs.push(
        new LotteryInstallmentConfigurationModel(
          data.key,
          data.lotteryInstKey,
          data.installmentType,
          data.installmentPercent,
          data.instPaymentInterestRate,
          data.installmentDuePaymentDays,
          data.installmentDuePaymentDaysWithInterest,
          data.otherCharge,
          data.installmentAmount,
          data.lotteryKey,
          data.intrestChartLst
        )
      );

      this.lotteryInstallmentConfigs = this.lotteryInstallmentConfigs.sort(
        (a, b) => a.key - b.key
      );
    }
    // }
    // else {
    //   this.installmentConfigService.errorToast("Total Installment Percent is already - "+totalPercent);
    // }
  }
  formatDate(dateString: string | null): string {
    if (dateString === null) {
      return "";
    }
    const options: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      // timeZoneName: "short",
    };

    const formattedDate = new Date(dateString).toLocaleDateString(
      "en-GB",
      options
    );

    return formattedDate;
  }
  deleteLotteryInstallmentConfig(key: number) {
    this.lotteryInstallmentConfigs = this.lotteryInstallmentConfigs.filter(
      (o) => o.key !== key
    );
  }
  deleteLotteryIntersetConfig(key: number) {
    this.lotteryInstallmentConfigs = this.lotteryInstallmentConfigs.filter(
      (o) => o.key !== key
    );
  }

  async onSchemeInstallmentConfigurationAdd() {
    let totalPercent =
      this.schemeInstallmentConfigs &&
      this.schemeInstallmentConfigs.length > 0 &&
      this.schemeInstallmentConfigs.filter((s) => s.otherCharge === "N")
        .length > 0
        ? this.schemeInstallmentConfigs
            .filter((s) => s.otherCharge === "N")
            .map((obj) => obj.installmentPercent)
            .reduce((o1, o2) => o1 + o2)
        : 0;

    let otherCharges =
      this.schemeInstallmentConfigs &&
      this.schemeInstallmentConfigs.length > 0 &&
      this.schemeInstallmentConfigs.filter((s) => s.otherCharge === "Y")
        .length > 0
        ? Math.max.apply(
            Math,
            this.schemeInstallmentConfigs
              .filter((s) => s.otherCharge === "Y")
              .map((obj) => obj.key)
          ) + 1
        : 11;

    let otherInstallmentNamesT = this.otherInstallmentNames.filter(
      (o) =>
        (this.schemeInstallmentConfigs &&
        this.schemeInstallmentConfigs.length > 0
          ? this.schemeInstallmentConfigs
              .filter((l) => l.otherCharge === "Y")
              .map((l) => l.installmentType)
          : []
        ).indexOf(o) < 0
    );

    // if(totalPercent < 100) {
    let schemeInstallmentConfigKeys = this.schemeInstallmentConfigs?.map(
      (l) => l.key
    );
    let remainingInstallmentTypes = Object.keys(this.installmentTypes)
      ?.map((o) => {
        return { key: +o, value: this.installmentTypes[o] };
      })
      ?.filter((i) => schemeInstallmentConfigKeys.indexOf(i.key) < 0)
      .sort((a, b) => {
        return a.key - b.key;
      });
    let installmentType = remainingInstallmentTypes[0];

    const modal = await this.modalCtrl.create({
      component: InstallmentConfigModalComponent,
      cssClass: "master-modal-lg",
      componentProps: {
        installmentConfigurationType: "Scheme",
        header: this.schemes[this.schemeKey?.key],
        installmentType: totalPercent < 100 ? installmentType.value : null,
        installmentOrder: totalPercent < 100 ? installmentType.key : null,
        initialPercent: totalPercent < 100 ? 100 - totalPercent : 0,
        otherInstallmentType: !otherCharges ? "OTHER_CHARGES" : null,
        otherInstallmentOrder: otherCharges,
        otherInstallmentNames: otherInstallmentNamesT,
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === "submit") {
      console.log("data", data);
      this.schemeInstallmentConfigs.push(
        new SchemeInstallmentConfigurationModel(
          data.key,
          data.schemeInstKey,
          data.installmentType,
          data.installmentPercent,
          data.instPaymentInterestRate,
          data.installmentDuePaymentDays,
          data.installmentDuePaymentDaysWithInterest,
          data.otherCharge,
          data.installmentAmount,
          data.lotteryKey,
          data.schemeKey,
          data.intrestChartLst
        )
      );

      this.schemeInstallmentConfigs = this.schemeInstallmentConfigs.sort(
        (a, b) => a.key - b.key
      );
      console.log("dfg", this.schemeInstallmentConfigs);
    }
  }
  async onLotteryInstallmentConfigurationEdit(
    item: LotteryInstallmentConfigurationModel
  ) {
    console.log("item", item);
    const modal = await this.modalCtrl.create({
      component: InstallmentConfigEditModalComponent,
      cssClass: "master-modal-lg",
      componentProps: {
        installmentConfigurationType: "Lottery",
        header: this.lotteries[this.lotteryKey.key],
        installmentType: item.installmentType,
        installmentOrder: item.key,
        initialPercent: item.installmentPercent,
        initialPayDays: item.installmentDuePaymentDays,
        initialWithIntPayDays: item.installmentDuePaymentDaysWithInterest,
        otherInstallmentType: item.otherCharge === "Y" ? "OTHER_CHARGES" : null,
        otherInstallmentOrder: item.otherCharge === "Y" ? item.key : null,
        otherInstallmentNames: this.otherInstallmentNames,
        lotteryKey: this.lotteryKey.key,
        lotteryInstKey: item.lotteryInstKey,
        // isEdit: true, // Flag to indicate edit mode
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === "submit") {
      console.log("LotteryInstallmentConfigurationModeldata", data);

      const indexToUpdate = this.lotteryInstallmentConfigs.findIndex(
        (config) => config.installmentType === data.installmentType
      );

      if (indexToUpdate !== -1) {
        // Object with matching lotteryInstKey found, update it
        this.lotteryInstallmentConfigs[indexToUpdate] =
          new LotteryInstallmentConfigurationModel(
            data.key,
            data.lotteryInstKey,
            data.installmentType,
            data.installmentPercent,
            data.instPaymentInterestRate,
            data.installmentDuePaymentDays,
            data.installmentDuePaymentDaysWithInterest,
            data.otherCharge,
            data.installmentAmount,
            data.lotteryKey,
            data.intrestChartLst
          );
      } else {
        // Object with matching lotteryInstKey not found, push a new one
        this.lotteryInstallmentConfigs.push(
          new LotteryInstallmentConfigurationModel(
            data.key,
            data.lotteryInstKey,
            data.installmentType,
            data.installmentPercent,
            data.instPaymentInterestRate,
            data.installmentDuePaymentDays,
            data.installmentDuePaymentDaysWithInterest,
            data.otherCharge,
            data.installmentAmount,
            data.lotteryKey,
            data.intrestChartLst
          )
        );
      }

      this.lotteryInstallmentConfigs = this.lotteryInstallmentConfigs.sort(
        (a, b) => a.key - b.key
      );
    }
  }
  async onSchemeInstallmentConfigurationEdit(
    item: SchemeInstallmentConfigurationModel
  ) {
    console.log("item", item);
    console.log(" item.installmentType", item);
    const modal = await this.modalCtrl.create({
      component: InstallmentConfigEditModalComponent,
      cssClass: "master-modal-lg",
      componentProps: {
        installmentConfigurationType: "Scheme",
        header: this.schemes[this.schemeKey.key],
        installmentType: item.installmentType,
        installmentOrder: item.key,
        initialPercent: item.installmentPercent,
        initialPayDays: item.installmentDuePaymentDays,
        initialWithIntPayDays: item.installmentDuePaymentDaysWithInterest,
        otherInstallmentType: item.otherCharge === "Y" ? "OTHER_CHARGES" : null,
        otherInstallmentOrder: item.otherCharge === "Y" ? item.key : null,
        initialAmount: item.installmentAmount,
        otherInstallmentNames: this.otherInstallmentNames,
        lotteryKey: this.lotteryKey.key,
        schemeKey: this.schemeKey.key,
        schemeInstKey: item.schemeInstKey,
        // isEdit: true, // Flag to indicate edit mode
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === "submit") {
      console.log("SchemeInstallmentConfigurationModeldata", data);
      console.log("item.lotteryInstKey", item.schemeInstKey);
      const indexToUpdate = this.schemeInstallmentConfigs.findIndex(
        (config) => config.installmentType === data.installmentType
      );

      if (indexToUpdate !== -1) {
        // Object with matching schemeInstKey found, update it
        this.schemeInstallmentConfigs[indexToUpdate] =
          new SchemeInstallmentConfigurationModel(
            data.key,
            data.schemeInstKey,
            data.installmentType,
            data.installmentPercent,
            data.instPaymentInterestRate,
            data.installmentDuePaymentDays,
            data.installmentDuePaymentDaysWithInterest,
            data.otherCharge,
            data.installmentAmount,
            data.lotteryKey,
            data.schemeKey,
            data.intrestChartLst
          );
      } else {
        // Object with matching schemeInstKey not found, push a new one
        this.schemeInstallmentConfigs.push(
          new SchemeInstallmentConfigurationModel(
            data.key,
            data.schemeInstKey,
            data.installmentType,
            data.installmentPercent,
            data.instPaymentInterestRate,
            data.installmentDuePaymentDays,
            data.installmentDuePaymentDaysWithInterest,
            data.otherCharge,
            data.installmentAmount,
            data.lotteryKey,
            data.schemeKey,
            data.intrestChartLst
          )
        );
      }

      this.schemeInstallmentConfigs = this.schemeInstallmentConfigs.sort(
        (a, b) => a.key - b.key
      );
    }
  }

  deleteSchemeInstallmentConfig(key: number) {
    this.schemeInstallmentConfigs = this.schemeInstallmentConfigs.filter(
      (o) => o.key !== key
    );
  }
  deleteSchemeIntersetConfig(key: number) {
    this.schemeInstallmentConfigs = this.schemeInstallmentConfigs.filter(
      (o) => o.key !== key
    );
  }

  onLotteryInstallmentConfigurationSubmit() {
    if (
      this.lotteryInstallmentConfigs &&
      this.lotteryInstallmentConfigs.length > 0
    ) {
      let firstInstallment = this.lotteryInstallmentConfigs.filter(
        (obj) => obj.installmentType === "FIRS_INSTALLMENT"
      );

      if (!firstInstallment) {
        this.installmentConfigService.errorToast(
          "Installment Configuration should have First Installment"
        );
      }

      let totalPercent =
        this.lotteryInstallmentConfigs &&
        this.lotteryInstallmentConfigs.length > 0
          ? this.lotteryInstallmentConfigs
              .filter((o) => o.otherCharge === "N")
              .map((obj) => obj.installmentPercent)
              .reduce((o1, o2) => o1 + o2)
          : 0;

      if (totalPercent > 0) {
        this.installmentConfigService
          .saveLotteryInstallmentConfiguration(
            this.lotteryKey?.key,
            this.lotteryInstallmentConfigs
          )

          .subscribe(
            (data: any) => {
              this.isSubmitDisabled = false;
              if (data.status === "SUCCESS") {
                this.installmentConfigService.successToast(
                  "Saved Successfully"
                );
                this.onLotteryChange(this.lotteryKey);
              } else {
                this.installmentConfigService.errorToast(
                  data.errorMessage,
                  5 * 1000
                );
              }
            },
            (error) => {
              this.isSubmitDisabled = false;
              console.log(error);
              this.installmentConfigService.errorToast(
                error?.error?.message || error?.error?.errorMessage,
                5 * 1000
              );
            }
          );
      } else {
        this.installmentConfigService.errorToast(
          "Total Installment Percent should be greater than 0"
        );
      }
    } else {
      this.installmentConfigService.errorToast(
        "Please enter Installment Configuration for Lottery"
      );
    }
  }

  onSchemeInstallmentConfigurationSubmit() {
    console.log(
      " this.schemeInstallmentConfigs",
      this.schemeInstallmentConfigs
    );
    if (
      this.schemeInstallmentConfigs &&
      this.schemeInstallmentConfigs.length > 0
    ) {
      let firstInstallment = this.schemeInstallmentConfigs.filter(
        (obj) => obj.installmentType === "FIRS_INSTALLMENT"
      );

      if (!firstInstallment) {
        this.installmentConfigService.errorToast(
          "Installment Configuration should have First Installment"
        );
      }

      let totalPercent =
        this.schemeInstallmentConfigs &&
        this.schemeInstallmentConfigs.length > 0
          ? this.schemeInstallmentConfigs
              .filter((o) => o.otherCharge === "N")
              .map((obj) => obj.installmentPercent)
              .reduce((o1, o2) => o1 + o2)
          : 0;

      if (totalPercent > 0) {
        console.log(
          " this.schemeInstallmentConfigs",
          this.schemeInstallmentConfigs
        );
        this.installmentConfigService
          .saveSchemeInstallmentConfiguration(
            this.lotteryKey?.key,
            this.schemeKey?.key,
            this.schemeInstallmentConfigs
          )
          .subscribe(
            (data: any) => {
              this.isSubmitDisabled = false;
              if (data.status === "SUCCESS") {
                this.installmentConfigService.successToast(
                  "Saved Successfully"
                );
                this.onSchemeChange(this.schemeKey);
              } else {
                this.installmentConfigService.errorToast(
                  data.errorMessage,
                  5 * 1000
                );
              }
            },
            (error) => {
              this.isSubmitDisabled = false;
              console.log(error);
              this.installmentConfigService.errorToast(
                error?.error?.message || error?.error?.errorMessage,
                5 * 1000
              );
            }
          );
      } else {
        this.installmentConfigService.errorToast(
          "Total Installment Percent should be greater than 0"
        );
      }
    } else {
      this.installmentConfigService.errorToast(
        "Please enter Installment Configuration for Scheme"
      );
    }
  }

  onSearch1() {
    if (!this.selectedLottery) {
      return this.tenementInsConfigService.errorToast(
        "Please Select Lottery from the filter."
      );
    }

    if (!this.selectedScheme) {
      return this.tenementInsConfigService.errorToast(
        "Please Select Scheme from the filter."
      );
    }

    if (this.filterFormGroup.valid) {
      this.tenementInsConfigService
        .getAllTenementDtls(
          this.selectedLottery,
          this.selectedScheme,
          this?.selectedBldg,
          this?.selectedWing,
          this?.selectedFloor,
          this.currentPage,
          this.pageSize
        )
        .subscribe(
          (data) => {
            this.isLoading = false;
            if (data.status === "SUCCESS") {
              this.isSearchDisabled = false;

              this.tenementDetails = data.allTenements;
              this.dataSource = new MatTableDataSource(
                this.tenementDetails.content
              );
              setTimeout(() => {
                this.paginator.pageIndex = this.currentPage;
                this.paginator.length = this.tenementDetails.totalElements;
              });
              this.isLoading = false;
            } else {
              this.tenementInsConfigService.errorToast(data.errorMessage);
            }
          },
          (error) => {
            this.tenementInsConfigService.errorToast(
              error?.error?.message || error?.error?.errorMessage
            );
            this.isLoading = false;
          }
        );
    }
  }
}
